import wix from '../services/wix';
import { Message, chatSdk } from '@wix/chat-sdk';

export const sendMessage = ({
  message,
  chatroom,
  requestId,
}: {
  message: string;
  chatroom?: string;
  requestId: string;
}) => {
  return async function(dispatch, getState) {
    const responseEventName = `ChatWidget.sendMessageResponse.${requestId}`;
    if (!message) {
      console.error('`message` must be populated when sending message');
      return wix.publishToPubSub(responseEventName, { success: false });
    }

    try {
      const defaultChatroomId = getState().businessChatRoomId;
      const messageParam = {
        summary: message,
        chatroomId: chatroom ? chatroom : defaultChatroomId,
        text: message,
      };

      const messageObj: Message = Message.fromText(messageParam);
      chatSdk.sendMessage(messageObj);

      wix.publishToPubSub(responseEventName, { success: true });
    } catch (e) {
      console.error('Catch an error in sendMessage Action,', e);
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
